<template>
<b-form-group>
  <b-form-input
    @input="change"
    v-model="insertedName"
    list="my-list-id"
    type="text"
    placeholder="Enter the organisation's name">
  </b-form-input>
  <datalist id="my-list-id">
      <option v-for="existingName in existingNames">{{ existingName }}</option>
  </datalist>
  <p v-if="titleAlreadyExists()" class="text-left font-italic mt-2" style="color: red; font-size: 14px">* An organisation with this title already exists!</p>
  <p class="text-left font-italic" style="color: red; font-size: 14px">* Please avoid re-inserting the organization, in case it has been already inserted</p>
</b-form-group>
</template>

<script>
import {eventBus} from '../../main'
import axios from 'axios'

export default {
  name: 'OrgNameAutoComplete',
  props: {
    'currentName': String
  },
  data () {
    return {
      insertedName: this.currentName,
      existingNames: []
    }
  },
  methods: {
    change () {
      eventBus.$emit('organisationName', this.insertedName)
      axios.get('/organisation/namesByPrefix?start=0&count=10&prefix=' + this.insertedName,
        {withCredentials: true})
        .then(
          response => {
            console.log(response)
            this.existingNames = response.data
          })
    },
    titleAlreadyExists () {
      return this.existingNames.length === 1 && this.insertedName === this.existingNames[0]
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/organizations/OrgNameAutoComplete.vue